import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "title_tr", label: "Başlık (TR)", textarea: true },
  { key: "title_en", label: "Title (EN)", textarea: true },
  { key: "body1_tr", label: "1. paragraf (TR)", textarea: true },
  { key: "body1_en", label: "Paragraph 1 (EN)", textarea: true },
  { key: "body2_tr", label: "2. paragraf (TR)", textarea: true },
  { key: "body2_en", label: "Paragraph 2 (EN)", textarea: true },
];

export default function AdminAbout() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/content/about").then((r) => setForm(r.data.data || {})).catch(() => {});
  }, []);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/admin/content/about", { data: form });
      toast.success("Hakkımızda içeriği güncellendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-about-page" className="p-10 max-w-4xl">
      <div className="overline text-[#4A6A8F]">İçerik</div>
      <h1 className="font-serif-ap text-4xl text-[#0F2746] mt-3">Hakkımızda</h1>
      <p className="text-[#3A5170] mt-3">Hakkımızda sayfasının başlığını ve iki ana paragrafını düzenleyin.</p>

      <form onSubmit={save} className="mt-10 space-y-6">
        {FIELDS.map((f) => (
          <label key={f.key} className="block">
            <span className="overline text-[10px] text-[#4A6A8F] block mb-2">{f.label}</span>
            <textarea
              data-testid={`field-${f.key}`}
              value={form[f.key] || ""}
              onChange={onChange(f.key)}
              rows={4}
              className="w-full bg-white border border-[#0F2746]/30 focus:border-[#0F2746] outline-none p-3 text-[#0F2746] resize-none"
            />
          </label>
        ))}
        <button
          type="submit"
          disabled={loading}
          data-testid="save-about-btn"
          className="bg-[#0F2746] text-[#F3F5F8] hover:bg-[#081A33] disabled:opacity-50 px-8 py-3 text-xs uppercase tracking-[0.2em] flex items-center gap-2"
        >
          <Save size={14} /> {loading ? "..." : "Kaydet"}
        </button>
      </form>
    </div>
  );
}
